import Immutable from 'immutable';
import {
  HOME_PATH,
  EXPENSE_TYPE_PATH,
  TICKET_TAXABLE_INFORMATION_PATH,
  MANUAL_VOUCHER_PATH,
  BILLING_PATH,
  DETRACTION_PATH,
  EXPENSE_AUTHORIZER_USER_PATH,
  BANK_PATH,
  BANK_ACCOUNT_PATH,
  BILLING_REPORT_SUMMARY_PATH,
  BILLING_REPORT_DETAIL_PATH,
  BILLING_REPORT_RETENTION_PATH,
  BILLING_REPORT_SUMMARY_BY_DOCUMENT_PATH,
  EXPENSE_SAP_MIGRATION_PATH,
} from '../../../config/paths';

const INITIAL_STATE = Immutable.Map({
  cards: [
    {
      id: 'trip-expenses',
      title: 'Gastos de Viaje',
      path: '/accounting/trip-expense',
      icon: 'usd',
      disabled: false,
    },
    {
      id: 'expense-types',
      title: 'Tipos de Egreso',
      path: EXPENSE_TYPE_PATH,
      icon: 'list-ol',
    },
    {
      id: 'voucher-types',
      title: 'Tipos de comprobante',
      path: '/accounting/voucher-type',
      icon: 'envelope-o',
      disabled: false,
    },
    {
      id: 'payment-method',
      title: 'Métodos de Pago',
      path: '/accounting/payment-method',
      icon: 'credit-card-alt',
      disabled: false,
    },
    {
      id: 'sales-taxes',
      title: 'Impuestos a la Venta',
      path: '/accounting/sales-tax',
      icon: 'percent',
      disabled: false,
    },
    {
      id: 'exchange-rates',
      title: 'Tasas de Cambio',
      path: '/accounting/exchange-rate',
      icon: 'gg',
      disabled: false,
    },
    {
      id: 'liquidation-difference-reasons',
      title: 'Discrepancias de Liquidación',
      path: '/accounting/liquidation-difference-reason',
      icon: 'question-circle-o',
      disabled: false,
    },
    {
      id: 'general-income-types',
      title: 'Tipos de Ingreso',
      path: '/accounting/general-income-type',
      icon: 'list-ol',
      disabled: false,
    },
    {
      id: 'transactions',
      title: 'Transacción',
      path: '/accounting/transaction',
      icon: 'money',
      disabled: false,
    },
    {
      id: 'ticket-taxable-information',
      title: 'Control de Ingresos - Boletos',
      path: TICKET_TAXABLE_INFORMATION_PATH,
      icon: 'edit',
    },
    {
      id: 'manual-voucher',
      title: 'Comprobantes Manuales',
      path: MANUAL_VOUCHER_PATH,
      icon: 'print',
    },
    {
      id: 'accounting-reports',
      title: 'Reporte de Contabilidad',
      path: '/accounting/accounting-reports',
      icon: 'file-excel-o',
      disabled: true,
    },
    {
      id: 'billing',
      title: 'Sistema de emision electronica - Del Contribuyente',
      path: BILLING_PATH,
      icon: 'dollar',
    },
    {
      id: 'billing-report-summary',
      title: 'Resumen de Ventas Brutas por Tipo de Comprobante y Servicio',
      path: BILLING_REPORT_SUMMARY_PATH,
      icon: 'area-chart',
    },
    {
      id: 'billing-report-summary-by-document',
      title: 'Gestión de Ventas e Ingresos Electrónicos',
      path: BILLING_REPORT_SUMMARY_BY_DOCUMENT_PATH,
      icon: 'book',
    },
    {
      id: 'billing-report-detail',
      title: 'Registro de Ventas e Ingresos',
      path: BILLING_REPORT_DETAIL_PATH,
      icon: 'list',
    },
    {
      id: 'billing-report-retention-reversion',
      title: 'Retenciones y Reversiones',
      path: BILLING_REPORT_RETENTION_PATH,
      icon: 'exchange',
    },
    {
      id: 'detraction',
      title: 'Detracción',
      path: DETRACTION_PATH,
      icon: 'bank',
    },
    {
      id: 'expense-authorizer-user',
      title: 'Usuario Autorizador de gastos',
      path: EXPENSE_AUTHORIZER_USER_PATH,
      icon: 'user',
    },
    {
      id: 'bank',
      title: 'Bancos',
      path: BANK_PATH,
      icon: 'bank',
    },
    {
      id: 'bank-account',
      title: 'Cuentas Bancarias',
      path: BANK_ACCOUNT_PATH,
      icon: 'credit-card',
    },
    {
      id: 'expense-sap-migration',
      title: 'Egresos a SAP',
      path: EXPENSE_SAP_MIGRATION_PATH,
      icon: 'cloud-upload',
    },
  ],
  breadcrumbs: [
    {
      text: 'Inicio',
      tag: 'a',
      href: HOME_PATH,
    },
    {
      text: 'Contabilidad',
      tag: 'span',
      href: '/accounting',
    },
  ],
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
